import { render, staticRenderFns } from "./SocialMediaSelect.vue?vue&type=template&id=310468f5"
import script from "./SocialMediaSelect.vue?vue&type=script&lang=js"
export * from "./SocialMediaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports